import axios from 'axios';

const API_URL = 'https://s0ob9xvyuh.execute-api.us-east-1.amazonaws.com/prod/investment_type';

export const GetAllInvestmentTypes = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    console.log("InvestmentAPIHelper :: GetAllInvestmentTypes :: response :: " + response)
    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

// Assuming you have UpdateInvestmentType, DeleteInvestmentType endpoints
export const UpdateInvestmentType = async (investmentTypeId, investmentTypeName) => {
    try {
      const url = `${API_URL}?investmentTypeId=${investmentTypeId}`;
      const requestBody = {
        investment_type_id: investmentTypeId,
        investment_type_name: investmentTypeName
      };
  
      const response = await axios.put(url, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${token}`
        },
      });
  
      if (response.status === 200) {
        return response;
      } else {
        console.error('Error:', response.status, response.statusText);
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
};

export const DeleteInvestmentType = async (investmentTypeId) => {
  try {
    const url = `${API_URL}?investmentTypeId=${investmentTypeId}`;

    const response = await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};
